import { CircularProgress } from "@mui/material";

export const LoadingBarMinimal = () => {
    return <CircularProgress />;
};
